import ColourSwatches from "./ColourSwatches";
export default ColourSwatches;
